import {FC, ReactNode} from 'react'
import {createPortal} from 'react-dom'

/**
 * Renders modal content into <body>, escaping admin stacking contexts created by
 * the page entrance animations / `will-change: transform` cards — otherwise a
 * `position: fixed` modal gets trapped behind the sticky top header.
 */
export const ModalPortal: FC<{children: ReactNode}> = ({children}) =>
  createPortal(<>{children}</>, document.body)
